import { localeNumber } from '@hotjar/insights-common/lib/number';

const EXCEED_LIMIT_CHAR = '+';

export const formatRecordingsCount = (count: number, upperBound: number): string => {
  const isCapped = count >= upperBound;

  const countCapped = isCapped ? upperBound : count;
  const countText = localeNumber(countCapped);

  const countSuffix = isCapped ? EXCEED_LIMIT_CHAR : '';

  return `${countText}${countSuffix}`;
};
